export default class Asset extends Backbone.Model
  defaults:
    asset_id: 0
    persisted: false
    mediaLibAsset: false
    relationship: "assets"
    assetType: "standard"

  url: ->
    "/#{@assetablePath()}/#{@get("assetableId")}/#{@get("relationship")}/#{@get("asset_id")}"

  assetablePath: ->
    switch @get("assetableType")
      when "Story" then "stories"
      when "Field" then "fields"
      when "SocialPost" then "social_posts"

  save: (onSuccess) ->
    @onSuccess = onSuccess

    if @get("mediaLibAsset")
      @saveAssetting()
    else
      @processUpload()

  update: (data, callbacks) ->
    $.ajax
      type: "PUT"
      url: @url()
      dataType: "json"
      data: { asset: data }
      success: (data) =>
        @set(data.asset)
        callbacks.success() if callbacks.success
      error: ->
        callbacks.error() if callbacks.error
        contently.flash.alert("There was an error updating your file.")

  saveAssetting: ->
    $.ajax
      type: 'POST'
      url: @url() + '/assetting'
      data: { asset_type: @get("assetType") }
      success: =>
        @set(persisted: true)
        @onSuccess()
      error: @onSaveError

  onSaveError: (jqXHR, textStatus, errorThrown) =>
    @set("processing", false)
    jsonResponse = JSON.parse(jqXHR.responseText)
    if jsonResponse.errors
      contently.flash.alert(
        jsonResponse.errors[0]
      )
    else
      contently.flash.alert(
        "There was an error saving the file."
      )

  destroy: (options) ->
    $.ajax
      type: 'DELETE'
      url: @url()
      success: =>
        options.success()
      error: ->
        contently.flash.alert("There was an error deleting your asset.")

  hasThumbnail: ->
    return true if @get("mediaLibAsset")
    @get("fileType") in ["image/jpeg", "image/png", "image/pjpeg", "image/gif", "image/x-png", "image/bmp"]

  aboveFileSizeLimit: ->
    if !!@get("maxFileSize")
      parseInt(@get("filesize"), 10) > parseInt(@get("maxFileSize"), 10)
    else
      false

  processUpload: ->
    # Display placeholder on story assets panel UI to let user
    # know processing is happening in the background
    $("#pending-asset-list-item").removeClass('pending-asset-list-item-inactive')
    
    $.ajax
      url: "/media/s3_upload"
      type: 'POST'
      dataType: 'json'
      data: { data_remote_url: @get("url") }
      success: (data) =>
        # Remove placeholder telling users to wait for processing
        $("#pending-asset-list-item").addClass('pending-asset-list-item-inactive')
        @set
          asset_id: data.id
          url: data.url
          title: data.data_file_name
          thumb: data.thumb
          filesize: data.data_file_size
          createdBy: data.created_by

        @saveAssetting()
      error: ( jqXHR, textStatus, errorThrown ) =>
        story_id = @url().split('/')[2]
        # Check if asset has been saved every 60 seconds
        timeToCheckAssetStatusInMilliseconds = 60000
        
        timer = setInterval((=>
          $.ajax
            url: '/stories/' + story_id + '/assets/is_asset_saved'
            type: 'POST'
            dataType: 'json'
            data: { data_remote_url: @get("url") }
            success: (data) =>
              if data.is_saved
                # -------------------------------------------------
                # Note
                # -------------------------------------------------
                # In a local dev environment using a single thread,
                # these polling requests may stack up behind the http
                # request to save the asset.
                #
                # Once the asset saves, it is possible more than one
                # polling request will process with data.is_saved equal
                # to true.  This will cause this code to be run
                # multiple times and may lead to unexpected behavior
                # -------------------------------------------------
                clearInterval(timer)

                @set
                  asset_id: data.id
                  url: data.url
                  title: data.data_file_name
                  thumb: data.thumb
                  filesize: data.data_file_size
                  createdBy: data.created_by

                # Remove placeholder telling users to wait for processing
                $("#pending-asset-list-item").addClass('pending-asset-list-item-inactive')
                
                @saveAssetting()
        ), timeToCheckAssetStatusInMilliseconds)


// WEBPACK FOOTER //
// ./app/javascript/backbone/platform/models/assets/asset.js.coffee